import { useState, useEffect } from 'react'

export const useUnmountController = () => {
    const [unmountController] = useState(new AbortController())

    useEffect(() => {
        return () => unmountController.abort()
    }, [])

    return unmountController
}